export enum commodityStage{
  SERIAL_LIFE = "SERIAL_LIFE",
  SPARE_PART = "SPARE_PART",
  FDD = "FDD",
  NON_FDD = "NON_FDD"
}
export enum categoryType{
  UNDEFINED = "UNDEFINED",
  ACCESSORIES = "ACCESSORIES",
  AFTER_SALES = "AFTER_SALES",
  MATERIAL = "MATERIAL",
  PROTOTYPE = "PROTOTYPE",
  LINE_PART = "LINE_PART",
  TOOLING = "TOOLING",
  LOGISTIC = "LOGISTIC",
  MANDAT = "MANDAT"
}
export enum typeScope {
  BOP = "BOP",
  BIP = "BIP",
  NBOP = "NBOP"
}
export enum status {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  VALIDATED = "VALIDATED",
  INACTIVE = "INACTIVE",
  ARCHIVED = "ARCHIVED"
}
export class CommodityPerimeter {
  "code": string
  "endDate": string
  "lastUpdateDate": string
  "description": string
  "label": string
  "commodityStage": commodityStage
  "typeCode": string
  "rowId": string
  "categoryType": categoryType
  "typeId": string
  "onlyReporting": boolean
  "startDate": string
  "typeScope": typeScope
  "status": status
}
  export class CommodityPerimeters {
    "commodity-perimeters": CommodityPerimeter[]
  }

  export class AccessPointIdentifiers {
    "identifier": string
    "siteIdentifier": string
    "endDate": string
    "sourceSystemId": string
    "identifierValue": string
    "accessPointIdentifier": string
    "rowId": string
    "accessPointType": string
    "identifierId": string
    "sourceSystemName": string
    "accessPointRowId": string
    "effectiveDate": string
    "identifierTypeName": string
}